import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { spaAssetBase } from "../../api";

export function ModbusSharePublicHandshake({ token, search }: { token: string; search: string }) {
  const [stuck, setStuck] = useState(false);
  useEffect(() => {
    const qs =
      typeof search === "string" && search.startsWith("?")
        ? search
        : search
          ? `?${search}`
          : "";
    const path = `/modbus-device-view/public/${token}${qs}`;
    const api = spaAssetBase().replace(/\/$/, "");
    const absolute =
      api && /^https?:\/\//i.test(api)
        ? `${api}${path}`
        : `${window.location.origin}${path}`;
    try {
      const next = new URL(absolute).href.replace(/\/$/, "");
      const here = window.location.href.replace(/\/$/, "");
      if (next !== here) {
        window.location.replace(absolute);
        return;
      }
    } catch {
      window.location.replace(absolute);
      return;
    }
    queueMicrotask(() => setStuck(true));
  }, [token, search]);
  if (stuck) {
    return (
      <div className="grid min-h-screen place-items-center bg-slate-50 p-8 text-center text-slate-700">
        <div className="max-w-lg rounded-xl border border-amber-200 bg-amber-50 p-6 text-sm">
          <p className="font-semibold text-amber-900">Shared link could not reach the RMS API host</p>
          <p className="mt-2 text-slate-600">
            Open the link copied from Mapping (it should start with your API base URL, often <code className="text-xs">https://api.</code>
            …), or set <code className="text-xs">VITE_BACKEND_URL</code> in the frontend build to that API URL so open-in-new-tab flows can
            redirect correctly.
          </p>
        </div>
      </div>
    );
  }
  return (
    <div className="grid min-h-screen place-items-center bg-slate-50 text-slate-500">
      <div className="flex flex-col items-center gap-3 px-6 text-center">
        <Loader2 className="h-8 w-8 animate-spin" aria-hidden />
        <p className="text-sm text-slate-600">Opening secure shared link…</p>
      </div>
    </div>
  );
}
